import { useRoute } from '@react-navigation/native'
import { B5 } from '@zet/design-system'
import { Stack } from '@zet/design-system/layout'
import { Control, Controller, FieldValues } from 'react-hook-form'

import { useIsApplicationV2 } from '../../api/applicationDetails/hook'
import { UserDetailsProps } from '../../types'
import { IOcField, IOcFieldError } from '../../utils/types'
import FormComponent from './formComponent'
import useRules from './useRules'

interface Props {
  control: Control<FieldValues, any>
  ocFieldError?: IOcFieldError
  ocField: IOcField
  userDetails: UserDetailsProps
  state: any
}

const FormController: React.FC<Props> = (props) => {
  const { control, state, ocFieldError, ocField, userDetails } = props

  const { params, name } = useRoute()
  const { hash } = params ?? {}

  const isV2 = useIsApplicationV2(hash)

  const { isHide } = useRules({
    control,
    rules: ocField?.config?.rules,
  })

  if (isHide) {
    return null
  }

  return (
    <Controller
      control={control}
      name={String(isV2 ? ocField?.ocFieldCode : ocField?.id ?? '')}
      render={(formControllerRenderProps) => {
        return (
          <Stack className="my-2">
            <FormComponent
              formControllerRenderProps={formControllerRenderProps}
              formValidationError={formControllerRenderProps.fieldState.error}
              ocFieldError={ocFieldError}
              ocField={ocField}
              userDetails={userDetails}
              state={state}
            />
            {ocField?.description?.content && (
              <B5 className="mt-1">{ocField?.description?.content}</B5>
            )}
          </Stack>
        )
      }}
    />
  )
}

export default FormController
